import SystemDataService from '../Services/SystemDataService';
import DataSourceConfig from '../Config/DataSourceConfig';
import { ServiceEntity } from '../Entities';

// NOTE: keep everything above the first `export` free of Entity references, // scripts/seed-content-to-s3.js evaluates that part in a sandbox to extract
// serviceFormatter.

// --- 1. CACHE STORAGE ---
let ALL_SERVICES_CACHE = null;
const SERVICE_SLUG_CACHE = {};

const serviceFormatter = [
  // --- Item One ---
  {
    id: 'item-one',
    categoryId: 'item-one',
    isActive: true,
    slug: 'item-one',
    name: 'Item One',

    seo: {
      title: 'Item One | Your Business',
      description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
      keywords: 'keyword one, keyword two, keyword three',
      image: '/placeholder.svg'
    },

    card: {
      title: 'Item One',
      description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
      image: '/placeholder.svg',
      buttonText: 'Learn More'
    },

    hero: {
      label: 'ITEM ONE',
      title: 'Item One',
      subtitle: 'Headline goes here',
      description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
      imageDesktop: '/placeholder.svg',
      imageMobile: '/placeholder.svg',
      buttonText: 'Join Us',
      buttonHref: '/contact'
    },

    sections: [
      {
        id: 'intro',
        type: 'contentHero',
        label: 'Section Title',
        title: 'Headline goes here',
        subtitle: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
        backgroundImage: '/placeholder.svg',
        buttonText: 'Get Involved',
        buttonHref: '/contact'
      },
      {
        id: 'what-to-expect',
        type: 'grid',
        label: 'What to Expect',
        title: 'Section Title',
        subtitle: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
        items: [
          { title: 'Item One', description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.' },
          { title: 'Item Two', description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.' },
          { title: 'Item Three', description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.' },
          { title: 'Item Four', description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.' }
        ]
      },
      {
        id: 'final-cta',
        type: 'contentHero',
        label: 'Section Title',
        title: 'Headline goes here',
        subtitle: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
        backgroundImage: '/placeholder.svg',
        buttonText: 'Get in Touch',
        buttonHref: '/contact'
      }
    ],

    schema: {
      '@context': 'https://schema.org',
      '@type': 'Service',
      serviceType: 'Item One',
      provider: {
        '@type': 'Organization',
        name: 'Your Business',
        url: 'https://www.example.com'
      }
    }
  },
  {
    id: 'item-two',
    categoryId: 'item-two',
    isActive: true,
    slug: 'item-two',
    name: 'Item Two',

    seo: {
      title: 'Item Two | Your Business',
      description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
      keywords: 'keyword one, keyword two, keyword three',
      image: '/placeholder.svg'
    },

    card: {
      title: 'Item Two',
      description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
      image: '/placeholder.svg',
      buttonText: 'Learn More'
    },

    hero: {
      label: 'ITEM TWO',
      title: 'Item Two',
      subtitle: 'Headline goes here',
      description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
      imageDesktop: '/placeholder.svg',
      imageMobile: '/placeholder.svg',
      buttonText: 'Reserve a Spot',
      buttonHref: '/contact'
    },

    sections: [
      {
        id: 'intro',
        type: 'contentHero',
        label: 'Section Title',
        title: 'Headline goes here',
        subtitle: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
        backgroundImage: '/placeholder.svg',
        buttonText: 'Join Us',
        buttonHref: '/contact'
      },
      {
        id: 'what-to-expect',
        type: 'grid',
        label: 'What to Expect',
        title: 'Section Title',
        subtitle: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
        items: [
          { title: 'Item One', description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.' },
          { title: 'Item Two', description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.' },
          { title: 'Item Three', description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.' },
          { title: 'Item Four', description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.' }
        ]
      },
      {
        id: 'final-cta',
        type: 'contentHero',
        label: 'Section Title',
        title: 'Headline goes here',
        subtitle: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
        backgroundImage: '/placeholder.svg',
        buttonText: 'Reserve a Spot',
        buttonHref: '/contact'
      }
    ],

    schema: {
      '@context': 'https://schema.org',
      '@type': 'Service',
      serviceType: 'Item Two',
      provider: {
        '@type': 'Organization',
        name: 'Your Business',
        url: 'https://www.example.com'
      }
    }
  },
  {
    id: 'item-three',
    categoryId: 'item-three',
    isActive: true,
    slug: 'item-three',
    name: 'Item Three',

    seo: {
      title: 'Item Three | Your Business',
      description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
      keywords: 'keyword one, keyword two, keyword three',
      image: '/placeholder.svg'
    },

    card: {
      title: 'Item Three',
      description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
      image: '/placeholder.svg',
      buttonText: 'Learn More'
    },

    hero: {
      label: 'ITEM THREE',
      title: 'Item Three',
      subtitle: 'Headline goes here',
      description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
      imageDesktop: '/placeholder.svg',
      imageMobile: '/placeholder.svg',
      buttonText: 'See What\'s Next',
      buttonHref: '/contact'
    },

    sections: [
      {
        id: 'intro',
        type: 'contentHero',
        label: 'Section Title',
        title: 'Headline goes here',
        subtitle: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
        backgroundImage: '/placeholder.svg',
        buttonText: 'Get Involved',
        buttonHref: '/contact'
      },
      {
        id: 'what-to-expect',
        type: 'grid',
        label: 'What to Expect',
        title: 'Section Title',
        subtitle: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
        items: [
          { title: 'Item One', description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.' },
          { title: 'Item Two', description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.' },
          { title: 'Item Three', description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.' },
          { title: 'Item Four', description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.' }
        ]
      },
      {
        id: 'final-cta',
        type: 'contentHero',
        label: 'Section Title',
        title: 'Headline goes here',
        subtitle: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
        backgroundImage: '/placeholder.svg',
        buttonText: 'Get in Touch',
        buttonHref: '/contact'
      }
    ],

    schema: {
      '@context': 'https://schema.org',
      '@type': 'Service',
      serviceType: 'Item Three',
      provider: {
        '@type': 'Organization',
        name: 'Your Business',
        url: 'https://www.example.com'
      }
    }
  },
];

export default serviceFormatter;

// --- 2. CATEGORY METADATA ---

export const SERVICE_CATEGORIES_META = {
    'item-one': {
        name: { he: 'Item One', en: 'Item One' },
        description: {
            he: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
            en: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
        },
        image: '/placeholder.svg',
    },
    'item-two': {
        name: { he: 'Item Two', en: 'Item Two' },
        description: {
            he: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
            en: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
        },
        image: '/placeholder.svg',
    },
    'item-three': {
        name: { he: 'Item Three', en: 'Item Three' },
        description: {
            he: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
            en: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
        },
        image: '/placeholder.svg',
    },
};

// --- 3. FETCHING FUNCTIONS ---

export const getServicesData = async () => {
  if (ALL_SERVICES_CACHE) return ALL_SERVICES_CACHE;

  if (DataSourceConfig.services === 'local') {
    ALL_SERVICES_CACHE = ServiceEntity.list(serviceFormatter);
    return ALL_SERVICES_CACHE;
  }

  try {
    const apiData = await SystemDataService.getServicesData();
    if (Array.isArray(apiData) && apiData.length > 0) {
      ALL_SERVICES_CACHE = ServiceEntity.list(apiData);
      return ALL_SERVICES_CACHE;
    }
    console.warn('Services API returned empty, falling back to local formatter');
    ALL_SERVICES_CACHE = ServiceEntity.list(serviceFormatter);
    return ALL_SERVICES_CACHE;
  } catch (err) {
    console.error('Failed to load services data from API, using local fallback', err);
    return ServiceEntity.list(serviceFormatter);
  }
};

export const getAllServices = () => ServiceEntity.list(serviceFormatter);

export const getServiceBySlug = async (slug) => {
  if (SERVICE_SLUG_CACHE[slug]) return SERVICE_SLUG_CACHE[slug];

  // Check populated cache first (avoids extra API call if getServicesData already ran)
  if (ALL_SERVICES_CACHE) {
    const found = ALL_SERVICES_CACHE.find(s => s.slug === slug);
    if (found) { SERVICE_SLUG_CACHE[slug] = found; return found; }
  }

  if (DataSourceConfig.services === 'local') {
    const result = ServiceEntity.from(serviceFormatter.find(s => s.slug === slug) || null);
    if (result) SERVICE_SLUG_CACHE[slug] = result;
    return result;
  }

  try {
    const apiData = await SystemDataService.getServicesDataBySlug(slug);
    let result = null;
    if (Array.isArray(apiData)) {
      result = apiData.find(s => s.slug === slug) ?? null;
    } else if (apiData && typeof apiData === 'object' && apiData.slug === slug) {
      result = apiData;
    }
    result = ServiceEntity.from(result);
    if (result) { SERVICE_SLUG_CACHE[slug] = result; return result; }

    console.warn(`Service API empty for slug: ${slug}, falling back to local.`);
    const localResult = ServiceEntity.from(serviceFormatter.find(s => s.slug === slug) || null);
    if (localResult) SERVICE_SLUG_CACHE[slug] = localResult;
    return localResult;
  } catch (err) {
    console.error('Failed to load specific service from API, using local fallback', err);
    return ServiceEntity.from(serviceFormatter.find(s => s.slug === slug) || null);
  }
};

export const getServiceCategories = async (language = 'en') => {
    const services = await getServicesData();
    const seen = new Set();
    const categoryIds = [];
    for (const s of services) {
        if (s.categoryId && !seen.has(s.categoryId)) {
            seen.add(s.categoryId);
            categoryIds.push(s.categoryId);
        }
    }
    return categoryIds.map(id => {
        const meta = SERVICE_CATEGORIES_META[id] || {};
        const inCategory = services.filter(s => s.categoryId === id);
        return {
            id,
            slug: id,
            name: meta.name?.[language] || id,
            description: meta.description?.[language] || '',
            image: meta.image || inCategory[0]?.card?.image || '/placeholder.svg',
            count: inCategory.length,
        };
    });
};

export const isValidService = (slug) => {
  return serviceFormatter.some(service => service.slug === slug);
};

export const clearServicesCache = () => {
  ALL_SERVICES_CACHE = null;
};
